module.exports = __webpack_public_path__ + "img/success.491d3db7.svg";